import { Slider } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled as muiStyle } from "@mui/material/styles";
import styled from "styled-components";
import { setColor, setFont } from "../../../assets/styles/styles";

export const HallwaySlider = ({
    sliderColor,
    highValue,
    lowValue,
    circleColor,
    step,
    sliderWidth,
    sliderHeight,
    onChange,
    ...props
}) => {
    const [value, setValue] = useState(props.value);

    const PrettoSlider = muiStyle(Slider)(({ theme }) => ({
        color: sliderColor,
        height: 123,
        width: 4,
        "& .MuiSlider-track": {
            border: "none",
            padding: "0",
        },
        "& .MuiSlider-thumb": {
            height: 20,
            width: 17,
            borderRadius: 0,
            boxShadow: `0px 5px 8px ${setColor.boxshadowOne}`,
            backgroundColor: circleColor || sliderColor,
            clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                boxShadow: `0px 5px 8px ${setColor.boxshadowOne}`,
            },
            "&:before": {
                display: "none",
            },
        },
        // Responsive height for mobile
        "@media (max-width:768px), (max-height:470px)": {
            height: 110,
        },
    }));

    return (
        <>
            <OuterDiv sliderWidth={sliderWidth} sliderHeight={sliderHeight}>
                <PrettoSlider
                    valueLabelDisplay="off"
                    aria-label="pretto slider"
                    orientation="vertical"
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                        onChange(newValue);
                    }}
                    max={Number.parseInt(highValue, 10)}
                    min={Number.parseInt(lowValue, 10)}
                    step={step}
                />
            </OuterDiv>
        </>
    );
};

HallwaySlider.propTypes = {
    sliderColor: PropTypes.string,
    highValue: PropTypes.string,
    lowValue: PropTypes.string,
    circleColor: PropTypes.string,
    step: PropTypes.number,
    sliderWidth: PropTypes.string,
    sliderHeight: PropTypes.string,
};

HallwaySlider.defaultProps = {
    sliderColor: setColor.accent4,
    highValue: "",
    lowValue: "",
    circleColor: "",
    step: 1,
    sliderWidth: "",
};

const OuterDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    flex-wrap: nowrap;
    margin: auto;
    margin-top: 5px;
    width: ${(props) => (props.sliderWidth ? props.sliderWidth : "40px")};
    height: ${(props) => (props.sliderHeight ? props.sliderHeight : "152px")};

    @media (max-width: 768px), (max-height: 470px) {
        width: 30px !important;
        height: 128px !important;
        margin: 2px 0 0 0;
        margin-bottom: 4px;
        align-self: flex-start;
    }
`;
